import {
	GET_SALES_PASSENGERS,
	GET_SALES_PASSENGERS_SUCCESS,
	GET_SALES_PASSENGERS_ERROR,
	GET_SALES_PASSENGERS_NOT_FOUND,
	GET_PROGRAMS,
	GET_PROGRAMS_SUCCESS,
	GET_PROGRAMS_ERROR,
	MY_PASSENGERS_FILTERED
} from "../shared/constants";
import { decDaysToDate, formatDateToComputerDate, incDaysToDate } from "../shared/utils";

const iniCancellation = {
	fetchingSales: true,
	errorPrograms: false,
	errorSales: false,
	fetchingPrograms: false,
	filteredStatements: {
		startDate: formatDateToComputerDate(decDaysToDate(new Date(), 365)),
		endDate: formatDateToComputerDate(new Date()),
		programId: 3
	},
	data: {
		logs: [],
		totalMiles: 0,
		averageMiles: 0,
		totalValue: 0,
		countReductionsUsed: null
	},
	programs: []
};

export const PassengersReducer = (state = iniCancellation, { payload, type }) => {
	switch (type) {
		case GET_SALES_PASSENGERS:
			return {
				...state,
				fetchingSales: true,
				errorSales: false
			};
		case GET_SALES_PASSENGERS_SUCCESS:
			return {
				...state,
				data: {
					...state.data,
					...payload
				},
				fetchingSales: false,
				errorSales: false
			};
		case GET_SALES_PASSENGERS_NOT_FOUND:
			return {
				...state,
				data: {
					logs: []
				},
				fetchingSales: false
			};
		case GET_SALES_PASSENGERS_ERROR:
			return {
				...state,
				fetchingSales: false,
				errorSales: payload
			};
		case GET_PROGRAMS:
			return {
				...state,
				fetchingPrograms: true,
				errorPrograms: false
			};
		case GET_PROGRAMS_SUCCESS:
			return {
				...state,
				programs: payload,
				fetchingPrograms: false,
				errorPrograms: false
			};
		case GET_PROGRAMS_ERROR:
			return {
				...state,
				errorPrograms: payload,
				fetchingPrograms: false
			};
		case MY_PASSENGERS_FILTERED:
			return {
				...state,
				filteredStatements: payload.filteredStatements
			};
		default:
			return state;
	}
};
